import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
export default {
    methods: {
        getList() {
            let params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                AgentId: this.AgentId
            }
            $http.get("api/Agent/GetAgentEmployeeList", params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.$nextTick(() => {
                        this.DataList = Data;
                    });
                });
            });
        },
        toggleStatus(params){
            $http.get("api/Agent/AuthAgentEmployee",params).then(res=>{
                util.doResult(this,res,()=>{
                     this.$message('操作成功');
                     this.getList();
                })
            })
        },
        clearChildImei(params){
            $http.get("api/Agent/ClearAgentChildImei",params).then(res=>{
                util.doResult(this,res,()=>{
                    this.$message("清除IMEI成功");
                    this.getList();
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/childAccount/services.js